import { ThemeProvider } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useState } from 'react'
import { Route, Router, Switch } from 'react-router-dom'
import theme from './styles/stylesVariables'

import DrawerNavigation from './components/DrawerNavigation'
import Context from './context'
import Login from './pages/Login'
import history from './services/history'
import GlobalStyle from './styles/global'

function App() {
  const [user, setUser] = useState(null)
  const [userPartner, setUserPartner] = useState(null)
  const [editCourtesy, setEditCourtesy] = useState(null)
  const [editPartner, setEditPartner] = useState({ id: null })
  const [editUnity, setEditUnity] = useState({ id: null, partnerId: null })
  const [editEvent, setEditEvent] = useState({ id: null })
  const [partnerToEdit, setPartnerToEdit] = useState(null)
  const [screenList, setScreenList] = useState([])
  const [openSideBar, setOpenSideBar] = useState(true)
  const [unityData, setUnityData] = useState(null)
  const [aboutCurrentPage, setAboutCurrentPage] = useState({})
  const [showLoadingModal, setShowLoadingModal] = useState(false)
  const [openToast, setOpenToast] = useState({
    open: false,
    message: '',
    type: 'success'
  })
  const [rangeDate, setRangeDate] = useState([
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ])

  return (
    <Context.Provider
      value={{
        user,
        setUser,
        aboutCurrentPage,
        setAboutCurrentPage,
        openSideBar,
        setOpenSideBar,
        userPartner,
        setUserPartner,
        editCourtesy,
        setEditCourtesy,
        editPartner,
        setEditPartner,
        editUnity,
        setEditUnity,
        screenList,
        setScreenList,
        partnerToEdit,
        setPartnerToEdit,
        editEvent,
        setEditEvent,
        showLoadingModal,
        setShowLoadingModal,
        openToast,
        setOpenToast,
        rangeDate,
        setRangeDate,
        unityData,
        setUnityData
      }}
    >
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <Switch>
            <Route path="/" exact component={Login} />
            <DrawerNavigation />
          </Switch>
          <GlobalStyle />
        </Router>
      </ThemeProvider>
    </Context.Provider>
  )
}

export default App
